import { Button } from "components/Button";
import { Alert } from "components/common/Alert/Alert";
import { CustomDatoImage } from "components/CustomDatoImage/CustomDatoImage";
import { useTranslationContext } from "context/translation";
import { useNewsletterForm } from "hooks/newsletter/useNewsletterForm";
import { FC } from "react";
import { StructuredText } from "react-datocms/structured-text";
import { Field, Form } from "react-final-form";
import {
  AllBlogSectionsQuery,
  NewsletterFragment,
  ResponsiveImage,
} from "services/datocms/generated";
import st from "./blog-homepage-header.module.scss";

interface Props {
  selectedCategory?: AllBlogSectionsQuery["allBlogSections"][number] | null;
  pageTitle?: string;
  newsletterData?: NewsletterFragment | null;
  blogHomepageHero?: ResponsiveImage | null;
}

const BlogHomepageHeader: FC<Props> = ({
  selectedCategory,
  pageTitle,
  newsletterData,
  blogHomepageHero,
}) => {
  const allSelected = !selectedCategory;
  const { onSubmit, data, error } = useNewsletterForm(newsletterData);
  const { unknownError } = useTranslationContext();

  return (
    <div className={st.headerContainer}>
      {allSelected && blogHomepageHero && (
        <div className={st.heroImage}>
          <CustomDatoImage
            layout="fill"
            objectFit="cover"
            data={blogHomepageHero}
            priority
          />
        </div>
      )}
      {!allSelected && selectedCategory?.heroVisual?.responsiveImage && (
        <div className={st.heroImage}>
          <CustomDatoImage
            layout="fill"
            objectFit="cover"
            data={selectedCategory?.heroVisual?.responsiveImage}
            priority
          />
        </div>
      )}
      <h1 className="md:mt-28">
        {allSelected ? pageTitle : selectedCategory.title}
      </h1>
      {allSelected && newsletterData && (
        <Form onSubmit={onSubmit}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className={st.newsletterContainer}>
              {data ? (
                <StructuredText data={newsletterData.completedText} />
              ) : (
                <>
                  <span className={st.title}>{newsletterData.headerText}</span>
                  <Field
                    component="input"
                    name="email"
                    type="email"
                    className={st.emailInput}
                    placeholder={newsletterData.emailPlaceholder ?? ""}
                    required
                  />
                  <div className={st.checkboxContainer}>
                    {newsletterData.showFirstTermsCheckbox ? (
                      <>
                        <Field
                          component="input"
                          type="checkbox"
                          name="accept_marketing"
                          id="acceptMarketing"
                        />
                        <label htmlFor="acceptMarketing">
                          <StructuredText data={newsletterData.firstTerms} />
                        </label>
                      </>
                    ) : (
                      <StructuredText data={newsletterData.firstTerms} />
                    )}
                  </div>
                  <div className={st.checkboxContainer}>
                    {newsletterData.showSecondTermsCheckbox ? (
                      <>
                        <Field
                          component="input"
                          type="checkbox"
                          name="accept_marketing"
                          id="acceptMarketing"
                        />
                        <label htmlFor="acceptMarketing">
                          <StructuredText data={newsletterData.secondTerms} />
                        </label>
                      </>
                    ) : (
                      <StructuredText data={newsletterData.secondTerms} />
                    )}
                  </div>
                  <Button type="submit" className={st.subscribeButton}>
                    {newsletterData.subscribeButtonText}
                  </Button>
                  {error && <Alert type="error">{unknownError}</Alert>}
                </>
              )}
            </form>
          )}
        </Form>
      )}
    </div>
  );
};

export default BlogHomepageHeader;
